module.exports = __webpack_public_path__ + "img/sounds.6671654c.png";